import { Button, Grid, Typography } from '@mui/material';

import { gridSpacing } from 'store/constant';

import Error404 from 'assets/images/clipart/error-404.png';
import AuthHeader from 'layout/MainLayout/Header/AuthHeader';
import { IconHome } from '@tabler/icons-react';

const Error = () => {
    return (
        <>
            <AuthHeader />
            <Grid container justifyContent="center" spacing={gridSpacing}>
                <Grid item xs={12} textAlign={'center'}>
                    <img src={Error404} alt="Error" draggable={false} style={{ width: '500px' }} />
                </Grid>
                <Grid item xs={12} textAlign="center">
                    <Typography variant="h4" color="textPrimary" gutterBottom>
                        Page Not Found
                    </Typography>
                    <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                        Oops! The page you’re looking for doesn’t exist.
                    </Typography>
                    <Button variant="outlined" color="secondary" startIcon={<IconHome />} href={'/'}>
                        Go to Homepage
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default Error;
